import { OnboardingToolbar } from './OnboardingToolbar';
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { ONBOARDING_STEP_INDUSTRY, OnboardingStepAnswer } from '../types';
import { useOnboardingWizardStepAnalyticsPage } from '../hooks/useOnboardingWizardStepAnalyticsPage';

export const IndustryStep = (props: {
  stepIndex: number;
  totalSteps: number;
  onNext: (answers: OnboardingStepAnswer[]) => void;
  onSkip: () => void;
}) => {
  useOnboardingWizardStepAnalyticsPage(ONBOARDING_STEP_INDUSTRY);
  const { stepIndex, totalSteps, onNext, onSkip } = props;
  const [industry, setIndustry] = useState('');
  const onNextHandler = () => onNext([{ name: 'industry', value: industry }]);
  return (
    <div className="onboarding-step__container">
      <Form.Group className="onboarding-step__row">
        <label>What industry does your business primarily operate in?</label>
        <input
          autoFocus={true}
          placeholder="e-commerce, real estate, etc."
          value={industry}
          data-test="onboarding-industry__input"
          onChange={(
            e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
          ) => setIndustry(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              onNextHandler();
            }
          }}
          className="growegy-form__input flex-grow-1"
        />
      </Form.Group>
      <OnboardingToolbar
        stepIndex={stepIndex}
        totalSteps={totalSteps}
        nextDisabled={industry.trim().length === 0}
        onNext={onNextHandler}
        onSkip={onSkip}
      />
    </div>
  );
};
